export const printOptions = [
  { value: 'ItemCode', label: 'Item Code' },
  {
    value: 'ItemDescription',
    label: 'Item Description',
  },
];



// WEBPACK FOOTER //
// ./src/common/Constants/print.js